import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export enum ObstacleType {
    BOOMERANG,
    DINOSAUR,
    DYE,
    FUUJIN,
    FUUJIN_PROJECTILE,
    LANTERN,
    PALETAS,
    PALETAS_PROJECTILE,
    PARROT,
    PIGEON,
    SCARAB,
    SPUTNIK,
    NUM_ELEMENTS,
}

export class Obstacles {
    // private static _data: ReadonlyArray<ObstacleData>;

    // public static get data(): ReadonlyArray<ObstacleData> {
    //     if (this._data === undefined) {
    //         this._data = Obstacles.initData();
    //     }
    //     return this._data;
    // }

    // private static initData(): ReadonlyArray<ObstacleData> {
    //     const data: ObstacleData[] = new Array<ObstacleData>(ObstacleType.NUM_ELEMENTS);

    //     data[ObstacleType.BOOMERANG] = new ObstacleData();

    //     return data;
    // }
}
